<div
  class="flex flex-col w-full space-y-4 max-h-full overflow-y-auto"
  nrcInfiniteScroll
  [threshold]="infiniteScrollConfig.threshold || 200"
  [debounceTime]="infiniteScrollConfig.debounceTime || 100"
  [isInfiniteScrollDisabled]="!infiniteScrollConfig.enabled || !hasMoreData || isLoadingMore"
  (scrolledToBottom)="handleScrolledToBottom()"
>
  @for (item of items(); track rowIndex; let rowIndex = $index) {
    <div
      class="w-full flex items-start gap-4 animate-fade-in-up relative z-0 hover:z-50 transition-all"
      attr.id="row-card-item-{{rowIndex}}"
      [style.animation-delay]="(rowIndex * 30) + 'ms'"
      [style.animation-fill-mode]="'both'"
    >
    @if (config.enableAlphabetHeader) {
        <!-- Alphabet Letter Display -->
        <div class="flex-shrink-0 w-8 flex justify-center pt-4">
          @if (rowIndex === 0 || (items()?.[rowIndex - 1]?.value | firstLetter: config.columns[0] && config.columns[0].key : true) !== (item.value | firstLetter: config.columns[0].key : true)) {
            <span class="text-3xl font-bold text-blue-400 animate-scale-in">
              {{ item.value | firstLetter: config.columns[0] && config.columns[0].key : true }}
            </span>
          }
        </div>
      }
      <!-- Card Content -->
      @for (column of config.columns; track $index) {
        <div class="flex-1">
          @if (!column['visibilityFn'] || column['visibilityFn'](item.value | extractProperty: column.key)) {
            <nrc-row-card-item
              class="w-full transition-all duration-300 ease-in-out hover:scale-[1.02] hover:shadow-lg"
              [index]="rowIndex"
              [config]="{
                title: (item.value | extractProperty: column.key | toString) || '',
                subtitle: column.additionalInfoKeys ? (item.value | extractProperties: column.additionalInfoKeys | join: ' | ') : undefined,
                icon: undefined,
                actionButtons: config.itemActionButtons,
                isSelected: item.isSelected,
                disabled: false,
                thumbnailConfig: column.thumbnailConfig || undefined,
                thumbnailSource: (column.thumbnailConfig && column.thumbnailConfig.thumbnailSourceKey) ? (item.value | extractProperty: column.thumbnailConfig.thumbnailSourceKey | toString) : ((column.thumbnailConfig && column.thumbnailConfig.fallbackThumbnailSourceKey) ? (item.value | extractProperty: column.thumbnailConfig.fallbackThumbnailSourceKey | toString) : undefined),
                mimetype: (column.thumbnailConfig && column.thumbnailConfig.mimetypeKey) ? (item.value | extractProperty: column.thumbnailConfig.mimetypeKey | toString) : ((column.thumbnailConfig && column.thumbnailConfig.fallbackMimetypeKey) ? (item.value | extractProperty: column.thumbnailConfig.fallbackMimetypeKey | toString) : undefined)
              }"
              (itemClickEvent)="handleRowCardItemClickedEvent(item, rowIndex)"
              (actionButtonEvent)="handleItemAction({ index: rowIndex, actionButton: $event.actionButton })"
            />
          }
        </div>
      }
    </div>
  }

  <!-- End of List Indicator -->
  @if (infiniteScrollConfig.enabled && !hasMoreData && items()?.length && !isLoadingMore) {
    <div class="flex justify-center items-center py-4">
      <span class="text-sm text-gray-400">No more items to load</span>
    </div>
  }
</div>
